module.exports = __webpack_public_path__ + "img/4.5d6ed710.webp";